import { IResPonderaciones, IListaPonderacionIndividual, IResCrearPonderacion, ICalendarizacion, IDetallePonderacion } from 'src/app/interfaces/ponderaciones';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { Component, OnInit } from '@angular/core';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { IListaAnhos } from 'src/app/interfaces/ponderaciones';
import { NgxSpinnerService } from 'ngx-spinner';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { Router } from '@angular/router';
import { customEnv } from 'src/environments/customEnv';

@Component({
  selector: 'app-view-ponderacion-individual-inicio',
  templateUrl: './view-ponderacion-individual-inicio.component.html',
  styleUrls: ['./view-ponderacion-individual-inicio.component.scss']
})
export class ViewPonderacionIndividualInicioComponent implements OnInit {
  dtOptions: DataTables.Settings | any = { ...DatatableConfig.dtOptionsWithPopOver }
  renderTable: boolean = true
  popoverItems: Array<Object> = [
    {
      texto: 'Editar',
      icono: 'bi-pencil-square'
    },
    {
      texto: 'Editar',
      icono: 'bi-pencil-square'
    },
    {
      texto: 'Eliminar',
      icono: 'bi-trash'
    }
  ]
  filtroAnhos: Array<number> = []
  calificacionesParciales: Array<any> = []
  calificacionesExamenes: Array<any> = []
  minimaParciales: number = 0
  minimaExamenes: number = 0
  listaPonderacionIndividuales: Array<IListaPonderacionIndividual> = []
  notasParciales: Array<IResPonderaciones> = []
  
  filtroAnhoSeleccionado: number | null = null
  filtroPeriodos: Array<any> = []
  filtroPeriodoSeleccionado: number | '' = ''
  filtroSedes: Array<any> = []
  filtroSedeSeleccionado: number | '' = ''
  filtroAsignaturas: Array<any> = []
  filtroAsignaturaSeleccionado: number | '' = ''
  filtroSecciones: Array<any> = []
  filtroSeccionSeleccionado: number | '' = ''

  habilitarBtnConfig: boolean = false
  habilitarEditar: boolean = false
  habilitarEliminar: boolean = false
  alertaExitosa: string = ''

  calendarizacion: Array<ICalendarizacion> = []
  dataEliminar: any = null

  infoModalTitulo: string = ''
  infoModalTexto: string = ''
  configData: any = null;
  configFiltrosAnterior: any = null;
  rolUsuario: number | null = null;

  detallePonderacion: Array<IDetallePonderacion> = [];
  cantidadCalificacion: any = null
  rolDaraCentral: boolean = false

  isLast: boolean = false

  constructor(
    private _ponderaciones: PonderacionesService,
    private spinner: NgxSpinnerService,
    private _perfilamiento: PerfilamientoService,
    private router: Router
  ) {
    let user = this._perfilamiento.getUsuario();
    this.rolUsuario = user.rolId;

    if ( user.nombreRol === 'R_DARA_C' ) {
      this.rolDaraCentral = true
    }
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.ponderacionCreada ) {
      this.alertaExitosa = 'La ponderación ha sido creada exitosamente.'
      setTimeout(() => {
        this.alertaExitosa = ''
      }, 15000);
    }
    if(routerData?.ponderacionEditada) {
      this.alertaExitosa = "La ponderación ha sido modificada exitosamente.";
      setTimeout(() => {
        this.alertaExitosa = "";
      }, 15000);
    }
    if (routerData?.configuracion) {
      this.configFiltrosAnterior = {};
      this.configFiltrosAnterior = routerData.configuracion;
      this.filtroAnhoSeleccionado = routerData.configuracion.anyo;
      this.getFiltros("");
    }else {
      this.getAnhos()
    }
  }
  getFiltros(filtro: string): void {
    switch (filtro) {
      case 'anyo':
        this.getPeriodos();
        break;
      case 'periodos':
        this.getAsignaturas();
        break;
      case 'asignaturas':
        this.getSedesAsignatura()
        break;
      default:
        this.getAnhos();
        break;
    }
    
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtOptionsWithPopOver };
  }

  getAnhos() {
    this._ponderaciones.getFiltrosAnhos().subscribe(
      (res: IListaAnhos) => {
        this.filtroAnhos = res.anyos
        if(this.configFiltrosAnterior) {
          this.getFiltros("anyo");
        }else {
          this.getPeriodos();
        }
      }, (err: any) => {
      }
    )
  }

  getConfiguracionCalificaciones() {
    this.habilitarBtnConfig = false
    const anho: number = this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : 0
    const idPeriodo: number = this.filtroPeriodoSeleccionado ? Number(this.filtroPeriodoSeleccionado) : 0
    const idAsignatura: number = this.filtroAsignaturaSeleccionado ? Number(this.filtroAsignaturaSeleccionado) : 0
    this._ponderaciones.getConfiguracionBase(anho, idPeriodo, idAsignatura).subscribe(
      (res: IResPonderaciones) => {
        if (res.notasParciales) {
          this.calificacionesParciales = res.notasParciales
          this.minimaParciales = this.calificacionesParciales.length
          this.calificacionesExamenes = res.examenes
          this.minimaExamenes = this.calificacionesExamenes.length
          // this.habilitarBtnConfig = true
          this.obtenerCalendarizacion()
          this.habilitarBtnConfig = true
        }

      }, (err: any) => {
    })
  }

  getPeriodos() {
    this._ponderaciones.getFiltrosPeriodos(Number(this.filtroAnhoSeleccionado)).subscribe(
      (res: any) => {
        this.filtroPeriodos = res.periodos
        if(this.configFiltrosAnterior) {
          this.filtroPeriodoSeleccionado = this.configFiltrosAnterior.periodoId;
          this.getFiltros("periodos")
        }
      }
    )
  }

  getSedesAsignatura() {
    this._ponderaciones.getFiltrosSedesSigla(this._perfilamiento.getUsuario()?.usuarioId,
    Number(this.filtroAnhoSeleccionado),
    Number(this.filtroPeriodoSeleccionado),
    Number(this.filtroAsignaturaSeleccionado)
    ).subscribe(
      (res: any) => {
        this.filtroSedes = res.sedes
        this.filtroSecciones = [];
        if ( this.configFiltrosAnterior) {
          this.filtroSedeSeleccionado = this.configFiltrosAnterior.sedeId == 0 ? "" :this.configFiltrosAnterior.sedeId;
          if (this.configFiltrosAnterior.sedeId === 0) {
            delete this.configFiltrosAnterior;
            this.obtenerListaPonderacionIndividual();
          }
          
          if (this.filtroSedeSeleccionado !== "") {
            this.seleccionFiltro('sede')
          } else {
            this.getSecciones();
          }
        }
      }, err => {
      }
    )
    
  }

  getSedes() {
    this._ponderaciones.getFiltrosSedesSigla(this._perfilamiento.getUsuario()?.usuarioId,
    Number(this.filtroAnhoSeleccionado),
    Number(this.filtroPeriodoSeleccionado),
    Number(this.filtroAsignaturaSeleccionado)
    ).subscribe(
      (res: any) => {
        this.filtroSedes = res.sedes
        if(this.configFiltrosAnterior) {
          this.filtroSedeSeleccionado = this.configFiltrosAnterior.sedeId == 0 ? "" :this.configFiltrosAnterior.sedeId;
          this.seleccionFiltro('sede')
        }
      }
    )
  }

  getAsignaturas() {
    let sedeId = this.filtroSedeSeleccionado !== '' ? Number(this.filtroSedeSeleccionado) : 0
    this._ponderaciones.getFiltrosAsignaturas({
      anyo: Number(this.filtroAnhoSeleccionado),
      periodoId: Number(this.filtroPeriodoSeleccionado),
      sedeId: sedeId
    }).subscribe(
      (res: any) => {
        this.filtroAsignaturas = res.asignaturas
        if(this.configFiltrosAnterior) {
          this.filtroAsignaturaSeleccionado = this.configFiltrosAnterior.asignaturaId;
          this.getFiltros("asignaturas")
        }
      }
    )
  }

  getSecciones() {
    if ( this.filtroSedeSeleccionado != 0) {
      this._ponderaciones.getFiltrosSecciones({
        anyo: Number(this.filtroAnhoSeleccionado),
        periodoId: Number(this.filtroPeriodoSeleccionado),
        sedeId: Number(this.filtroSedeSeleccionado),
        asignaturaId: Number(this.filtroAsignaturaSeleccionado)
      }).subscribe(
        (res: any) => {
          this.filtroSecciones = res.secciones
          if(this.configFiltrosAnterior) {
            this.filtroSeccionSeleccionado = this.configFiltrosAnterior.seccionId == 0 ? "" :this.configFiltrosAnterior.seccionId;
            delete this.configFiltrosAnterior;
            this.obtenerListaPonderacionIndividual();
          }
        }
      )
    } else {
      this.filtroSecciones = [];
    }
  }

  seleccionFiltro(filtro: string = '') {
    switch (filtro) {
      case 'anho':
          this.getPeriodos()
          this.filtroPeriodoSeleccionado = ''
          this.filtroAsignaturaSeleccionado = ''
          this.filtroSeccionSeleccionado = ''
          this.filtroSedeSeleccionado = ''
        break;
      case 'periodo':
          this.getAsignaturas()
          this.filtroAsignaturaSeleccionado = ''
          this.filtroSeccionSeleccionado = ''
          this.filtroSedeSeleccionado = ''
        break;
      case 'asignatura':
          this.getSedesAsignatura()
          this.filtroSeccionSeleccionado = ''
          this.filtroSedeSeleccionado = ''
        break;
      case 'sede':
        this.getSecciones();
        this.filtroSeccionSeleccionado = ''
        break;
      default:
        break;
    }
  }

  enabledBtnBusqueda() {
    let enabled = false
    if (this.rolUsuario === 2) {
      if (this.filtroSedeSeleccionado !== '' && this.filtroAnhoSeleccionado !== null && this.filtroPeriodoSeleccionado !== '' && this.filtroAsignaturaSeleccionado ) {
        enabled = true
      }
    } else if ( this.filtroAnhoSeleccionado !== null && this.filtroPeriodoSeleccionado !== '' && this.filtroAsignaturaSeleccionado ) {
      enabled = true
    }
    return enabled
  }

  limpiarBusqueda() {
    this.filtroAnhoSeleccionado = null
    this.filtroPeriodoSeleccionado = ''
    this.filtroSedeSeleccionado = ''
    this.filtroAsignaturaSeleccionado = ''
    this.filtroSeccionSeleccionado = ''

    this.filtroPeriodos = []
    this.filtroSedes = []
    this.filtroAsignaturas = []
    this.filtroSecciones = []

    this.calificacionesParciales = []
    this.calificacionesExamenes = []

    this.renderTable = false
  }

  buscarPonderacion() {
    this.obtenerListaPonderacionIndividual()
  }

  totalParciales() {
    let total: number = 0
    this.calificacionesParciales.forEach(element => {
      if ( typeof element.porcentaje === 'number' )
        total += element.porcentaje
    });
    return total
  }

  totalExamenes() {
    let total: number = 0
    this.calificacionesExamenes.forEach(element => {
      total += element.porcentaje
      
    });
    return total
  }

  obtenerListaPonderacionIndividual(): void {
    let body = {
      anyo: this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : 0,
      periodoId: this.filtroPeriodoSeleccionado !== '' ? Number(this.filtroPeriodoSeleccionado) : 0,
      asignaturaId: this.filtroAsignaturaSeleccionado !== '' ? Number(this.filtroAsignaturaSeleccionado) : 0,
      sedeId: this.filtroSedeSeleccionado !== '' ? Number(this.filtroSedeSeleccionado) : 0,
      seccionId: this.filtroSeccionSeleccionado !== '' ? Number(this.filtroSeccionSeleccionado) : 0,
    }
    this.renderTable = false
    this._ponderaciones.listaPonderacionIndividual(body).subscribe(
      (res: any) => {
        this.listaPonderacionIndividuales = res
        this.renderTable = true
        this.getConfiguracionCalificaciones()
      }, err => {
      }
    )
  }

  navToCrearPonderacion() {
    let configuracion = {
      anyo: this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : 0,
      periodoId: this.filtroPeriodoSeleccionado !== '' ? Number(this.filtroPeriodoSeleccionado) : 0,
      asignaturaId: this.filtroAsignaturaSeleccionado !== '' ? Number(this.filtroAsignaturaSeleccionado) : 0,
      sedeId: this.filtroSedeSeleccionado !== '' ? Number(this.filtroSedeSeleccionado) : 0,
      seccionId: this.filtroSeccionSeleccionado !== '' ? Number(this.filtroSeccionSeleccionado) : 0,
    }
    this.router.navigate(['/ponderacion-individual-crear'], { state: { data: { configuracion } } })
  }

  obtenerCalendarizacion(){
    this.habilitarBtnConfig = false
    this.habilitarEditar = false
    this.habilitarEliminar = false

    let anho: number = this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : 0
    let idPeriodo: number = this.filtroPeriodoSeleccionado ? Number(this.filtroPeriodoSeleccionado) : 0
    let codigoProceso: string = customEnv.pondIndividual

    this._ponderaciones.getCalendarizacion(anho,idPeriodo,codigoProceso).subscribe(
      (res:ICalendarizacion) => {
        if(res.modificable === true){
          this.habilitarBtnConfig = true
          this.habilitarEditar = true
          this.habilitarEliminar = true
        }else{
          this.habilitarBtnConfig = false
        }
      }
    )
  }

  mostrarDetallePonderacion(ponderacionBaseId:number,tipoNota:string,seccion:string){
    this._ponderaciones.detalleNotaPonderacion(ponderacionBaseId,tipoNota,seccion).subscribe(
      (res:IDetallePonderacion)=>{
        this.cantidadCalificacion = res
        if ( this.cantidadCalificacion.length === 0 ) {
          this.cantidadCalificacion = [{
            ponderacionBaseId,
            tipoNota,
            seccion,
            cantidad: 0
          }]
        }
        if(tipoNota=='CP'){
          document.getElementById('btn-cantidadcp')?.click()
        }else{
          document.getElementById('btn-cantidadex')?.click()
        }
        
      },
      (err:any)=>{
      }
    )
  }
  
  navToEditarPonderacion(ponderacion: any) {
    let configuracion = {
      anyo: this.filtroAnhoSeleccionado ? Number(this.filtroAnhoSeleccionado) : 0,
      periodoId: this.filtroPeriodoSeleccionado !== '' ? Number(this.filtroPeriodoSeleccionado) : 0,
      asignaturaId: this.filtroAsignaturaSeleccionado !== '' ? Number(this.filtroAsignaturaSeleccionado) : 0,
      sedeId: this.filtroSedeSeleccionado !== '' ? Number(this.filtroSedeSeleccionado) : 0,
      seccionId: this.filtroSeccionSeleccionado !== '' ? Number(this.filtroSeccionSeleccionado) : 0,
      ponderacionId: ponderacion.ponderacionBaseId,
      estado: ponderacion.estado,
      ponderacionBaseId: ponderacion.ponderacionBaseId
    }
    this.router.navigate(['/ponderacion-individual-editar'], { state: { data: { configuracion } } });
  }

  mostrarAlertaExito(texto: string) {
    this.alertaExitosa = texto
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setTimeout(() => {
      this.alertaExitosa = ''
    }, 3000);
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo
    this.infoModalTexto = texto
    document.getElementById('btn-modal-info')?.click()
  }

  eliminarPonderacion(ponderacion: object) {
    this.dataEliminar = ponderacion
    document.getElementById('modalEliminarBtn')?.click()
  }

  confirmarEliminar() {
    this._ponderaciones.eliminarPonderacionIndividual(this.dataEliminar.ponderacionBaseId).subscribe(
      (res: IResCrearPonderacion) => {
        if ( res.error === null ) {
          this.mostrarAlertaExito(`Se ha eliminado la configuración de la sección ${this.dataEliminar.seccion ? this.dataEliminar.seccion : ''} exitosamente`)
          this.obtenerListaPonderacionIndividual()
        } else if (res.codigo !== 200 && res.codigo !== 404) {
          this.mostrarInfoModal('Error', res?.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios.')
        }
      }, (err: any) => {
        // this.mostrarInfoModal('Error', 'Hubo un error en los servicios')
      }
    )

  }
}
